import ipAddress from "./ipAddress.js";

module.exports = class ipv6Address extends ipAddress {};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv6Address.js